import type { StaticDataRouteOption } from "@tanstack/react-router"

import { AppNavigation } from "../NavigationView/AppNavigation"
import { ProcedureInitiativesViewTopBar } from "./TopBar"

export const procedureInitiativesViewStaticData: StaticDataRouteOption = {
	leftSlideOut: AppNavigation,
	topBar: ProcedureInitiativesViewTopBar,
}
